(function ($) {
  const string_to_slug = function (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
    var to = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace('.', '-') // replace a dot by a dash
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
      .replace(/-+/g, '-') // collapse dashes
      .replace(/\//g, ''); // collapse all forward-slashes

    return str;
  }

  // $(document).ready(function () {
  //Generate Navigation Links
  const quickNav = document.querySelector('.quick-navigation-wrap nav');

  if (!quickNav) {
    return;
  }

  let countH2 = 0;
  document.querySelectorAll('article h2').forEach(function (h2) {
    const id = string_to_slug(h2.id || h2.innerText.toLowerCase().trim());
    let text = h2.innerText;
    if (text.length > 50) {
      text = text.substring(0, 47) + '...';
    }
    h2.id = id;
    h2.insertAdjacentHTML('beforebegin', '<a name="' + id + '" style="visibility:hidden"></a>')
    quickNav.insertAdjacentHTML('beforeend', '<a href="#' + id + '">' + text + '</a>');
    countH2++;
  });

  if (countH2 > 2) {
    quickNav.parentElement.classList.add('nav-show');
  }

  const links = $('.quick-navigation-wrap .anchors a');

  links.on('click', function (e) {
    e.preventDefault();
    var offset = -100; // <-- change the value here
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top + offset
        }, 1000);
        return false;
      }
    }
  });

  //highlight menu on scrolling
  var lastId,
    // Anchors corresponding to menu items
    scrollItems = links.map(function () {
      var item = $(this).attr("href");
      if (item != '#') {
        return $(item);
      }
    });


  $(window).scroll(function () {
    // Get container scroll position
    var fromTop = $(this).scrollTop() + 120;

    // Get id of current scroll item
    var cur = scrollItems.map(function () {
      if ($(this).offset().top < fromTop) {
        return this;
      }
    });

    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      links
        .removeClass("active")
        .filter("[href='#" + id + "']").addClass("active");
    }
  });
  //end highlight menu on scrolling

  // });
})(jQuery);